import React from 'react';
import Title from '../../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router';

// August 16th: Refactored for responsiveness
const Information = ({ className }) => {
    return (
        <div className={`${className} w3-container w3-content pb-8 pt-8`}>
            <Title text="INFORMATION" />
            <div className="d-flex flex-column margin-top-double">
                <div className="d-flex flex-row">
                    <Link to="/about" className="w-100">
                        <ScrollAnimation animateIn="fadeInLeftBig" animateOnce={true} className="w-100  d-flex flex-row"
                            style={{ height: 226, margin: 1, background: 'url("/images/backgrounds/mud.jpg") no-repeat center top', backgroundSize: 'cover' }}>
                            <span className="white align-self-center w-100 text-center font-20">ABOUT US</span>
                        </ScrollAnimation>
                    </Link>
                    <div style={{ width: 4 }} />
                    <Link to="/information" className="w-100"><ScrollAnimation animateIn="fadeInRightBig" animateOnce={true} className="w-100  d-flex flex-row" style={{ height: 226, margin: 1, backgroundColor: '#252525' }}>
                        <span className="white align-self-center w-100 text-center font-20">GENERAL<br />INFORMATION</span>
                    </ScrollAnimation>
                    </Link>
                </div>
                <div className="d-flex row-into-column">
                    <div className="d-flex flex-row w-100">
                        <Link to="/divisions" className="w-100"><ScrollAnimation animateIn="fadeInLeftBig" animateOnce={true} className="w-100  d-flex flex-row" style={{ height: 226, margin: 1, backgroundColor: '#d92229' }}>
                            <span className="white align-self-center w-100 text-center font-20">1ST | 2ND DIVISION</span>
                        </ScrollAnimation></Link>
                        <div style={{ width: 4 }} />
                        <Link to="/rules" className="w-100"><ScrollAnimation animateIn="fadeIn" animateOnce={true} className="w-100  d-flex flex-row" style={{ height: 226, margin: 1, background: 'url("/images/backgrounds/red-card.jpg") no-repeat center top', backgroundSize: 'cover' }}>
                            <span className="white align-self-center w-100 text-center font-20">RULES</span>
                        </ScrollAnimation></Link>
                    </div>
                    <div style={{ width: 4 }} />
                    <div className="d-flex reverse-768 w-100">
                        <Link to="/express" className="w-100">
                            <ScrollAnimation animateIn="fadeIn" animateOnce={true} className="w-100 d-flex flex-row" style={{ height: 226, margin: 1, backgroundColor: '#d92229' }}>
                                <span className="white align-self-center w-100 text-center font-20">EXPRESS<br />CHECK IN</span>
                            </ScrollAnimation></Link>
                        <div style={{ width: 4 }} />
                        <Link to="/passport" className="w-100">
                            <ScrollAnimation animateIn="fadeInRightBig" animateOnce={true} className="w-100  d-flex flex-row" style={{ height: 226, margin: 1, background: 'url("/images/others/medals.jpg") no-repeat center bottom', backgroundSize: 'cover' }}>
                                <span className="white align-self-center w-100 text-center font-20">PASSPORT</span>
                            </ScrollAnimation>
                        </Link>
                    </div>
                </div>
                <div className="d-flex flex-row">
                    <a href="https://www.sportslogic.net/help/" className="w-100">
                        <ScrollAnimation animateIn="fadeInLeftBig" animateOnce={true} className="w-100  d-flex flex-row" style={{ height: 226, margin: 1, backgroundColor: '#252525' }}>
                            <span className="white align-self-center w-100 text-center font-20">SPORTS LOGIC<br />SL TEAM APP</span>
                        </ScrollAnimation>
                    </a>
                    <Link to="/weather" className="w-100">
                        <ScrollAnimation animateIn="fadeInRightBig" animateOnce={true} className="w-100 d-flex flex-row" style={{
                            height: 226, margin: 1,
                            background: 'url("/images/others/storm-final.jpg") no-repeat center bottom', backgroundSize: 'cover'
                        }}>
                            <span className="white align-self-center w-100 text-center font-20">GUARANTEE &<br />WEATHER POLICY<br />PROCEDURES</span>
                        </ScrollAnimation>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Information;



// WEBPACK FOOTER //
// ./src/components/information/partials/home.js